import { BrowserModule } from '@angular/platform-browser';
import { forwardRef, NgModule, inject, provideAppInitializer } from '@angular/core';

import { AppComponent } from './app.component';
import { CommonModule, LocationStrategy } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgbDropdownConfig, NgbModal, NgbModalConfig, NgbModule, NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../environments/environment';

import "@angular/compiler"
import { ApiInterceptor, DataService, EnvironmentService, ExperienceFinderModule, LocalizationService, MapStylesService, NotificationsService, OptionMapsService, PgUiControlsModule, PgUiElementsModule, PgUiMoleculesModule, UpdateCheckerService, PreserveQueryParamsPathLocationStrategy, AnalyticsService, PGUtilities, PersistenceService } from 'pg-lib';
import { EfLandingComponent } from './ef-landing/ef-landing.component';
import { AppRoutingModule } from './app-routing.module';
import { EfShowcaseViewComponent } from './ef-showcase-view/ef-showcase-view.component';
import { EfProductViewComponent } from './ef-product-view/ef-product-view.component';

@NgModule({ declarations: [
        AppComponent,
        EfLandingComponent,
        EfShowcaseViewComponent,
        EfProductViewComponent
    ],
    bootstrap: [AppComponent], imports: [CommonModule,
        BrowserModule,
        FormsModule,
        NgbModule,
        AppRoutingModule,
        PgUiElementsModule,
        PgUiControlsModule,
        PgUiMoleculesModule,
        ExperienceFinderModule], providers: [provideAppInitializer(() => {
        const initializerFn = ((optionMapsService: OptionMapsService, environmentService: EnvironmentService, ngbDropdownConfig: NgbDropdownConfig, ngbTooltipConfig: NgbTooltipConfig, ngbModalConfig: NgbModalConfig, ngbModal: NgbModal, localizationService: LocalizationService, mapStylesService: MapStylesService, updateCheckerService: UpdateCheckerService, notificationsService: NotificationsService, dataService: DataService, analyticsService: AnalyticsService, persistenceService: PersistenceService): Function => {
                return async () => {
                    persistenceService.activate();
                    ngbDropdownConfig.container = null;
                    ngbTooltipConfig.container = null;
                    ngbModalConfig.container = '.EFApp';
                    ngbModalConfig.backdrop = 'static';
                    ngbModalConfig.keyboard = false;
                    window.addEventListener('popstate', (event) => {
                        if (ngbModal.hasOpenModals()) {
                            ngbModal.dismissAll();
                        }
                    });
                    await environmentService.init(environment, 'experience-finder');
                    if (environmentService.getTimeUntilManteinance() > 0) {
                        dataService.init(environmentService, null);
                        if (environmentService.externalParameters.iframe == 'true' || environmentService.externalParameters.iframekiosk == 'true') {
                            persistenceService.consentData = {
                                'technical': true,
                                'analytics': true,
                                'technical_third_party': true
                            };
                        }
                        await localizationService.init();
                        await optionMapsService.init();
                        await mapStylesService.init();
                        await notificationsService.init();
                        updateCheckerService.init();
                        analyticsService.init('experience-finder');
                    }
                };
            })(inject(OptionMapsService), inject(EnvironmentService), inject(NgbDropdownConfig), inject(NgbTooltipConfig), inject(NgbModalConfig), inject(NgbModal), inject(LocalizationService), inject(MapStylesService), inject(UpdateCheckerService), inject(NotificationsService), inject(DataService), inject(AnalyticsService), inject(PersistenceService));
        return initializerFn();
      }), {
            provide: HTTP_INTERCEPTORS,
            useExisting: forwardRef(() => ApiInterceptor),
            multi: true
        }, {
            provide: LocationStrategy,
            useClass: PreserveQueryParamsPathLocationStrategy
        }, provideHttpClient(withInterceptorsFromDi())] })
export class AppModule { }
